<div>
    <div class="actions">
        <button (click)="backPage()" class="btn-action">
            <fa-icon [icon]="['fas', 'arrow-circle-left']" class="fa-thin"></fa-icon>
            Back
        </button>
        <button (click)="addBridge()" class="btn-action" *ngIf="isSuperUser">
            <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
            Add Bridge
        </button>
    </div>

    <div class="container-table">
        <div class="top-header">
            <h3>Bridges</h3>
            <p>Bridge management for {{ orgName }}</p>
        </div>
        <div>
            <app-shared-table-toolbar>
                <div toolbarSearch class="search-bar">
                    <app-generic-search
                            [apiUrl]="'bridges/search_suggestion'"
                            [resultsApiUrl]="'bridges/'"
                            [method]="'GET'"
                            [searchParamName]="'q'"
                            [extraBody]="searchExtraBody"
                            [pageSize]="10"
                            [minChars]="2"
                            (resultsFetched)="onResults($event)">
                    </app-generic-search>
                </div>
                <button toolbarTrailing type="button" (click)="exportToExcel()" class="export-button">
                    <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin"
                             style="color: white;font-size: 15px;"></fa-icon>
                    EXPORT EXCEL
                </button>
            </app-shared-table-toolbar>
            <div class="responsive-table-wrapper">
                <table>
                    <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Bridge Name</th>
                        <th>Bridge ESN</th>
                        <th>Organization</th>
                        <th>Credential</th>
                        <th>Status</th>
                        <th>Last Sync</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let record of bridgeData; let i = index">
                        <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
                        <td>{{ record.bridge_name }}</td>
                        <td>{{ record.bridge_esn }}</td>
                        <td>{{ record.organization }}</td>
                        <td>
                            <ng-container *ngIf="record.primary_masked_credential; else noCredential">
                                <span class="credential-badge">{{ record.primary_masked_credential }}</span>
                                <app-copy-button
                                        [value]="record.primary_masked_credential"
                                        copyTitle="Copy credential">
                                </app-copy-button>
                            </ng-container>
                            <ng-template #noCredential>
                                <span class="no-credential">No Credential</span>
                            </ng-template>
                        </td>
                        <td>
                <span class="status-pill" [class.active]="record.is_active" [class.inactive]="!record.is_active">
                  {{ record.is_active ? 'Enabled' : 'Disabled' }}
                </span>
                        </td>
                        <td>{{ formatRelativeTime(record.last_sync_at) }}</td>
                        <td class="table-actions-cell">
                            <div class="table-actions">
                            <label *ngIf="isSuperUser" class="toggle-switch"
                                   [title]="record.is_active ? 'Disable' : 'Enable'">
                                <input
                                        type="checkbox"
                                        [checked]="record.is_active"
                                        (change)="onToggleChange(record, $event)"
                                        [disabled]="record._toggling"/>
                                <span class="toggle-slider"></span>
                            </label>
                            <button *ngIf="isSuperUser" class="action-button bt-edit" (click)="updateBridge(record.id)"
                                    title="Edit">
                  <span>
                    <fa-icon [icon]="['fas', 'pen']" class="fa-light"></fa-icon>
                  </span>
                            </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="footer">
                    <div class="total-records">Total Records: {{ totalRecords }}</div>
                    <app-vte-pagination
                            [currentPage]="currentPage"
                            [pageSize]="recordsPerPage"
                            [totalRecords]="totalRecords"
                            [showJumpToPage]="true"
                            (pageChange)="onPageChange($event)"
                            (pageSizeChange)="onPageSizeChange($event)">
                    </app-vte-pagination>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showStatusConfirmationDialog" class="confirmation-modal">
    <div class="modal-content">
        <div class="modal-header">
            <i class="bi bi-exclamation-triangle warning-icon"></i>
            <h3>{{ statusDialogTitle }}</h3>
        </div>
        <div class="modal-body">
            <p>{{ statusDialogMessage }}</p>
        </div>
        <div class="modal-footer">
            <button (click)="confirmStatusChange()" class="confirm-btn modal-red">Yes, Proceed</button>
            <button (click)="closeStatusConfirmationDialog()" class="cancel-btn cancel-btn-green">Cancel</button>
        </div>
    </div>
</div>
